import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Shield, ArrowRight, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/admin/login', form);
      localStorage.setItem('admin_token', res.data.token);
      toast.success('Admin-Login erfolgreich');
      navigate('/admin');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 p-6" data-testid="admin-login-page">
      <Card className="w-full max-w-md bg-slate-900 border-slate-800">
        <CardHeader className="text-center space-y-3">
          <div className="mx-auto w-14 h-14 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center">
            <Shield className="w-7 h-7 text-amber-500" />
          </div>
          <CardTitle className="text-2xl font-bold text-white">Admin-Bereich</CardTitle>
          <CardDescription className="text-slate-400">Melden Sie sich mit Ihren Admin-Zugangsdaten an</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" className="text-slate-300">E-Mail</Label>
              <Input id="email" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                placeholder="admin@c-sniffer.de" required className="bg-slate-800 border-slate-700 text-white" data-testid="admin-email-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-slate-300">Passwort</Label>
              <Input id="password" type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                placeholder="Admin-Passwort" required className="bg-slate-800 border-slate-700 text-white" data-testid="admin-password-input" />
            </div>
            <Button type="submit" className="w-full bg-amber-600 hover:bg-amber-700 text-white" disabled={loading} data-testid="admin-login-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <span className="flex items-center gap-2">Anmelden <ArrowRight className="w-4 h-4" /></span>}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
